export const SET_USER_ID = 'SET_USER_ID';
export const SET_FINGERPRINT_ID = 'SET_FINGERPRINT_ID';
export const AUTHENTICATION_RESET_STATE = 'AUTHENTICATION_RESET_STATE';